import { appSchema, tableSchema } from '@nozbe/watermelondb'
import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs'
import { Database } from '@nozbe/watermelondb'
import { synchronize } from '@nozbe/watermelondb/sync'
import sendData from '../redux/actions/sendData'
import migrations from './migrations'
import { Task, TaskColumns } from './Task'
import { Media, MediaColumns } from './Media'
import { Q } from '@nozbe/watermelondb';
import { Comment, CommentColumns } from './Comment'
import { UserColumns, User } from './User'
import { TradeColumns, TradeType } from './TradeType'
import { RealmColumns, Realm } from './Realm'
import { unset, get, set, size } from '../global/lib/lodash'
import { awaitAll } from '../global/utils/awaitAll'
import { uploadFileToS3 } from '../redux/actions/imageUploader'

window.Q = Q;

const COLUMNS = {
  task: TaskColumns,
  tradeType: TradeColumns,
  comment: CommentColumns
}

const schema = appSchema({
    version: 1,
    tables: [
        tableSchema({
            name: 'task',
            columns: COLUMNS.task,
        }),
        tableSchema({
            name: 'media',
            columns: MediaColumns,
        }),
        tableSchema({
            name: 'comment',
            columns: CommentColumns,
        }),
        tableSchema({
            name: 'user',
            columns: UserColumns,
        }),
        tableSchema({
            name: 'tradeType',
            columns: COLUMNS.tradeType,
        }),
        tableSchema({
            name: 'realm',
            columns: RealmColumns,
        }),
    ]
})

export const adapter = new LokiJSAdapter({
  schema,
  // (You might want to comment out migrations for development purposes -- see Migrations documentation)
  migrations,
  useWebWorker: false,
  useIncrementalIndexedDB: true,
  dbName: 'perform', // optional db name

  // --- Optional, but recommended event handlers:

//   onQuotaExceededError: (error) => {
//     // Browser ran out of disk space -- offer the user to reload the app or log out
//   },
//   onSetUpError: (error) => {
//     // Database failed to load -- offer the user to reload the app or log out
//   },
//   extraIncrementalIDBOptions: {
//     onDidOverwrite: () => {
//       // Called when this adapter is forced to overwrite contents of IndexedDB.
//       // This happens if there's another open tab of the same app that's making changes.
//       // Try to synchronize the app now, and if user is offline, alert them that if they close this
//       // tab, some data may be lost
//     },
//     onversionchange: () => {
//       // database was deleted in another browser tab (user logged out), so we must make sure we delete
//       // it in this tab as well - usually best to just refresh the page
//     //   if (checkIfUserIsLoggedIn()) {
//     //     window.location.reload()
//     //   }
//     },
//   }
})

export const database = new Database({
  adapter,
  modelClasses: [
    Task,
    Media,
    Comment,
    TradeType,
    Realm,
    User
  ],
})

export const Sync = async () => {
  const newmedia = await database.get('media').query(
    Q.where('isNew', 1)
  );

  if (!!size(newmedia)) {
    await database.write(async () => {
      await awaitAll(newmedia.map(nm => () => async () => {
        const upl = await uploadFileToS3({ file: nm.fullUrl, name: nm.name });

        await nm.update(nmi => {
          nmi.content = `tmp/${get(upl, 'Key')}`;
          nmi.fullUrl = get(upl, 'response.url');
        })
        
        console.log({
          upl,
        })
      }), { queueSize: 5 });
    })
  }

  console.log({
    newmedia,
  })

  await synchronize({
    database,
    pullChanges: async ({ lastPulledAt, schemaVersion, migration }) => {
        try {
            // const urlParams = `last_pulled_at=${lastPulledAt}&schema_version=${schemaVersion}&migration=${encodeURIComponent(
            //   JSON.stringify(migration),
            // )}`
      
          //   const response = await fetch(`https://my.backend/sync?${urlParams}`)

            // return { timestamp: lastPulledAt };
      
            const response = await sendData({ url: `/sync?last_pulled_at=${lastPulledAt}` }, { useNamespace: false })

            const fixDates = (arr) => {
              const newChanges = [];
              arr.map(t => { 
                try {
                  if (!t.id) { return }

                  const jsons = ['meta'];
                  const joins = ['assignees', 'trade_types', 'authors'];
  
                  jsons.map(tt => {
                    if (t[tt]) { t[tt] = JSON.stringify(t[tt]) }
                  })

                  joins.map(tt => {
                    if (t[tt]) { t[tt] = t[tt].join(',') }
                  })
  
                  newChanges.push({
                    ...t,
                    created_at: new Date(t.created_at).getTime(),
                    updated_at: new Date(t.updated_at).getTime(),
                  });
                } catch (err) {
                  console.error(err);
                  debugger
                }
              })
              return newChanges;
            }

            [
              'task',
              'media',
              'comment',
              'user',
              'tradeType',
              'realm',
            ].map(k => {
              const key = `data.changes.${k}.created`;
              set(response, key, fixDates(get(response, key)))
            })

            console.log('done sync');

            return response.data;
        } catch (err) {
            console.error(err);
            return { timestamp: Date.now() / 1000 }
        }
    },
    pushChanges: async ({ changes, lastPulledAt }) => {
      try {

        const _changes = {};

        Object.keys(changes).map(k => {
          const { created, deleted, updated } = changes[k];

          const [_created, _updated, _deleted] = [created, deleted, updated].map(arr => arr.map(item => {
            const col = get(COLUMNS, k);

            if (col) {
              col.map(c => {
                const val = get(item, c.name);
                if (c.isRel && !!val) {
                  set(item, `relationships.${c.name}`, val.split(','))
                  unset(item, c.name);
                }
                if (c.isJson) {
                  set(item, c.name, JSON.parse(val))
                }
              })
            }

            return item;
          }))

          set(_changes, k, {
            updated: _updated,
            created: _created,
            deleted: _deleted,
          })
        })

        console.log({ _changes });

        // return {};

        const response = await sendData({ 
          url: `/sync?last_pulled_at=${lastPulledAt}`,
          method: 'POST',
          data: changes,
        }, { useNamespace: false })
    
        console.log({
          response,
        })
    
        return {};
      } catch (err) {
        console.error(err);
        return {};
      }
    },
    migrationsEnabledAtVersion: 1,
  })
}

window.CLEAR = async () => {
  await database.write(async () => {
    await database.unsafeResetDatabase();
  });
}

window.DB = database;
window.SYNC = Sync;